import React, { useState} from "react";
import { Dialog, DialogActionsBar} from "@progress/kendo-react-dialogs";
import {
    ExpansionPanel,
    ExpansionPanelContent,
} from "@progress/kendo-react-layout";
import { Button } from 'reactstrap';
import { Reveal } from "@progress/kendo-react-animation";
import { ExceptionDialogActions } from "./ExceptionDialogProvider"
import { useIntl } from "react-intl";
import PropTypes from 'prop-types';

const ExceptionDialog = ({ message, id, dispatch, dismissCallback }) => {
    const [exit, setExit] = useState(false);
    const [expanded, setExpanded] = React.useState(false);
    const intl = useIntl();

    const handleCloseExceptionDialog = () => {
        setExit(true);
        setTimeout(() => {
            dispatch({
                type: ExceptionDialogActions.REMOVE_EXCEPTION,
                id: id
            })
        }, 10)

        dismissCallback?.();
    };

    const getMessage = () => {
        let errorMessage = '';
        if (typeof message === 'string' || message instanceof String) {
            errorMessage = message;
        }
        else if (typeof message?.title === 'string' || message?.title instanceof String) {
            errorMessage = message.title;
            const translatedTitle = intl.formatMessage({ id: 'ExceptionDetails.Title' });
            errorMessage = errorMessage.replace('An error occurred while processing your request.', translatedTitle);
        }
        else {
            errorMessage = message?.response?.data?.detail ?? '';
        }
        return errorMessage;
    };

    const getDetail = () => {
        let errorMessage = '';
        if (typeof message?.detail === 'string' || message?.detail instanceof String) {
            errorMessage = message.detail;
        }
        else if (typeof message?.message === 'string' || message?.message instanceof String) {
            errorMessage = message.message;
        }
        return errorMessage;
    };

    return !exit && (
        <div>
            <Dialog title={intl.formatMessage({ id: 'ExceptionDetails.ExceptionDetails' })} className='exception-dialog'>
                <p className="exception-details">
                    {getMessage()}
                </p>
                {getDetail() !== "" &&
                    <ExpansionPanel
                        title={intl.formatMessage({ id: 'ExceptionDetails.Details' })}
                        expandIcon="fa fa-angle-down"
                        collapseIcon="fa fa-angle-up"
                        expanded={expanded}
                        onAction={(e) => setExpanded(!e.expanded)}
                    >
                        <Reveal>
                            {expanded && (
                                <ExpansionPanelContent>
                                    <span className="exception-details">
                                        {getDetail()}
                                    </span>
                                </ExpansionPanelContent>
                            )}
                        </Reveal>
                    </ExpansionPanel>
                }
                <span className="k-form-separator"></span>
                <DialogActionsBar>
                    <div >
                        <Button type={"submit"} onClick={handleCloseExceptionDialog} color="danger" className="btn btn-danger float-right">
                            {intl.formatMessage({ id: 'Control.Close' })}
                        </Button>
                    </div>
                </DialogActionsBar>
                
            </Dialog>
        </div>
    )
};

ExceptionDialog.propTypes = {
    id: PropTypes.string,
    message: PropTypes.object,
    dismissCallback: PropTypes.func,
    dispatch: PropTypes.func,
};

export default ExceptionDialog;
